import {
    preProductionFooterStyle,
    preProductionHeroBadgeStyle,
    preProductionHeroFillStyle,
    preProductionHeroStyle,
    preProductionHeroTrackStyle,
} from "../bisPatientStyles";
import { validatePreProductionButtonStyle } from "../bisProductionStyles";
import { SECTIONS } from "../bisVariant";
import { renderControlSection } from "./ControlSectionView";
import { ExtractionHpReport } from "../../shared/reports/ExtractionHpReport";

export function renderPreProductionTab(view) {
    const { blockingPatientIssues, controle, preProductionLocked, requestValidatePreProduction, uploadPreProductionAttachment, validatedPatientCount, workspace } = view;
    return (
    <>
        <div style={preProductionHeroStyle}>
            <div style={{ display: "grid", gap: "3px" }}>
                <strong style={{ color: "white", fontSize: "20px", fontWeight: 950 }}>Contrôle patient</strong>
                <span style={{ color: "#d8e6e1", fontSize: "13px", fontWeight: 750 }}>
                    {validatedPatientCount}/{controle.patients.length} patients validés · {blockingPatientIssues.length} à reprendre
                </span>
                <span style={preProductionHeroTrackStyle}>
                    <span style={{ ...preProductionHeroFillStyle, width: `${controle.patients.length ? Math.round((validatedPatientCount / controle.patients.length) * 100) : 0}%` }} />
                </span>
            </div>
            {blockingPatientIssues.length > 0 && (
                <span style={preProductionHeroBadgeStyle}>
                    ⚠ {blockingPatientIssues.length} patient{blockingPatientIssues.length > 1 ? "s" : ""} à reprendre
                </span>
            )}
        </div>
        {renderControlSection(view, SECTIONS[0], 0)}
        <ExtractionHpReport
            uploading={workspace.attachmentUploading}
            disabled={preProductionLocked}
            onUpload={uploadPreProductionAttachment}
        />
        <div style={preProductionFooterStyle}>
            <div style={{ color: "#475569", fontSize: "13px", fontWeight: 750 }}>
                {preProductionLocked
                    ? `Pré-production figée${workspace.formData.meta.preProductionValidatedBy ? ` par ${workspace.formData.meta.preProductionValidatedBy}` : ""}.`
                    : "Valider fige la pré-production dans son état actuel."}
            </div>
            <button
                type="button"
                onClick={requestValidatePreProduction}
                disabled={workspace.saving || preProductionLocked}
                style={{
                    ...validatePreProductionButtonStyle,
                    opacity: workspace.saving || preProductionLocked ? 0.6 : 1,
                    cursor: workspace.saving || preProductionLocked ? "not-allowed" : "pointer",
                }}
            >
                {preProductionLocked ? "Validé" : workspace.saving ? "Validation..." : "Validé"}
            </button>
        </div>
    </>
    );
}
